module.exports = __webpack_public_path__ + "img/source_book-item3.274eb73a.png";